import ErrorList from './ErrorList';

export default ErrorList;
